<app-expandable-section-box
  [title]="'Publish Time'"
  [iconClass]="'icon-clock-o'"
  [isExpandedByDefault]="isExpandedByDefault"
  [isExpandable]="isExpandable"
>
  <div class="flex flex-col flex-1 py-3" expandedContent>
    <mat-radio-group
      aria-label="Select an publish time"
      [formControl]="showPublishTimeControl"
    >
      <mat-radio-button *ngIf="enableAutomatic" [value]="false"
        >Automatic</mat-radio-button
      >
      <mat-radio-button [value]="true">Set Time</mat-radio-button>
    </mat-radio-group>
    <div
      class="flex flex-col border-t-2 border-dashed"
      *ngIf="showPublishTimeControl.value"
    >
      <div class="flex w-full space-x-2">
        <mat-form-field class="w-full" appearance="outline">
          <input
            matInput
            type="datetime-local"
            placeholder="Choose a date"
            [formControl]="publishTimeControl"
          />
          <mat-error class="pt-1">Please enter a publish date</mat-error>
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline">
        <mat-select [formControl]="timezoneControl" place>
          <mat-option
            *ngFor="let timezone of timezones; index as i"
            [value]="timezone.windowsTimezoneId"
          >
            {{ timezone.displayText }}
          </mat-option>
        </mat-select>
        <mat-error class="pt-1">Please select a timezone</mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="flex w-full p-4 m-0 text-xs text-project-2400" notExpandedContent>
    <div *ngIf="publishTimeControl.value; else noPublishTime">
      {{ publishTimeControl.value | date : "dd/MM/yyyy - HH:mm" }} ({{
        getTimezoneDisplayText(timezoneControl.value)
      }})
    </div>
    <ng-template #noPublishTime> Automatically </ng-template>
  </div>
</app-expandable-section-box>
